import ApiService from '@/api';
import {
  DeleteQueueInfoModel,
  QueueModel,
  QueueTasksModel,
  ResponseModel,
  UpdateQueueNameModel,
} from '../models';
import { mapGetListRequest, mapGetListResponse } from './AdapterServiceMappers';
import { Events } from 'tir-pm-toolkit';

export class AdapterService {
  private readonly api = new ApiService();

  /**Событие обновления названия очереди */
  OnUpdateQueueName = new Events<UpdateQueueNameModel>();
  /**Событие удаления очереди */
  DeleteQueueEvent = new Events<DeleteQueueInfoModel>();
  /**Событие создания очереди */
  CreateQueueEvent = new Events<QueueTasksModel>();

  constructor() {
    this.api.Main.ProjectQueueTaskService.OnUpdateNameQueueTaskEventEvent.on((resp) => {
      if (resp.IsSuccess && resp.Value) {
        this.OnUpdateQueueName.trigger({
          QueueId: resp.Value.Id,
          Name: resp.Value.Name,
        });
      }
    });
    this.api.Main.ProjectQueueTaskService.OnDeleteQueueTaskEventEvent.on((resp) => {
      if (resp.IsSuccess && resp.Value) {
        this.DeleteQueueEvent.trigger({
          QueueId: resp.Value.QueueTaskId,
        });
      }
    });
    this.api.Main.ProjectQueueTaskService.OnCreateQueueTaskEventEvent.on((resp) => {
      if (resp.IsSuccess && resp.Value) {
        this.DeleteQueueEvent.trigger({
          QueueId: resp.Value.Id,
        });
      }
    });
  }
  /**
   * * Получить список очередей
   * @param namespaceId ID неймспейса
   * @returns
   */
  getQueueList(namespaceId: string, OnlyPerformerCurrentUser: boolean) {
    return new Promise<ResponseModel<Array<QueueModel>>>(async (resolve) => {
      const result = new ResponseModel<Array<QueueModel>>();
      await this.api.Main.ProjectQueueTaskService.getListAsync(
        mapGetListRequest(namespaceId, OnlyPerformerCurrentUser),
      )
        .then((resp) => {
          result.Value = mapGetListResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getQueueList', e);
          return resolve(result);
        });
    });
  }
}
